export const CERTIFICATE_BOX_TEST_ID = "certificate-box";
